// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__oxaGN","meals-appear":"AvailableMeals_meals-appear__dSART","loading":"AvailableMeals_loading__ya-99","error":"AvailableMeals_error__ZnYTw"};